import { twMerge } from 'tailwind-merge';
import type { HtmlElementProps } from '@/types';
import { classes } from './utils';

export interface SectionProps extends HtmlElementProps {}

export default function Section({ className, ...props }: SectionProps) {
  return <div className={twMerge(classes.section, className)} {...props} />;
}
